import type { CurrencyCode } from '@99designs/i18n';

type BudgetRange = {
    [currency in CurrencyCode]: {
        [key: string]: Budget;
        low: Budget;
        moderate: Budget;
        high: Budget;
    };
};

interface Budget {
    fromPrice: number;
    toPrice?: number;
}

export const budgetRangesInCents: BudgetRange = {
    USD: {
        low: { fromPrice: 45000, toPrice: 99900 },
        moderate: { fromPrice: 100000, toPrice: 199900 },
        high: { fromPrice: 199900 },
    },
    AUD: {
        low: { fromPrice: 60000, toPrice: 139900 },
        moderate: { fromPrice: 140000, toPrice: 279900 },
        high: { fromPrice: 280000 },
    },
    CAD: {
        low: { fromPrice: 55000, toPrice: 134900 },
        moderate: { fromPrice: 135000, toPrice: 269900 },
        high: { fromPrice: 270000 },
    },
    GBP: {
        low: { fromPrice: 30000, toPrice: 79900 },
        moderate: { fromPrice: 80000, toPrice: 149900 },
        high: { fromPrice: 150000 },
    },
    EUR: {
        low: { fromPrice: 35000, toPrice: 89900 },
        moderate: { fromPrice: 90000, toPrice: 169900 },
        high: { fromPrice: 170000 },
    },
    DKK: {
        low: { fromPrice: 275000, toPrice: 639900 },
        moderate: {
            fromPrice: 640000,
            toPrice: 1269900,
        },
        high: { fromPrice: 127000 },
    },
    NOK: {
        low: { fromPrice: 400000, toPrice: 929900 },
        moderate: {
            fromPrice: 930000,
            toPrice: 1849900,
        },
        high: { fromPrice: 1850000 },
    },
    MXN: {
        low: { fromPrice: 940000, toPrice: 2159900 },
        moderate: {
            fromPrice: 2160000,
            toPrice: 4309900,
        },
        high: { fromPrice: 4310000 },
    },
    JPY: {
        low: { fromPrice: 47000, toPrice: 105499 },
        moderate: {
            fromPrice: 105500,
            toPrice: 210999,
        },
        high: { fromPrice: 211000 },
    },
    CHF: {
        low: { fromPrice: 40000, toPrice: 89900 },
        moderate: { fromPrice: 90000, toPrice: 179900 },
        high: { fromPrice: 180000 },
    },
    HKD: {
        low: { fromPrice: 340000, toPrice: 779900 },
        moderate: {
            fromPrice: 780000,
            toPrice: 1549900,
        },
        high: { fromPrice: 1550000 },
    },
    SGD: {
        low: { fromPrice: 55000, toPrice: 139900 },
        moderate: { fromPrice: 140000, toPrice: 269900 },
        high: { fromPrice: 270000 },
    },
};
